class ct_collapsible extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      this.toggle().bind(this);
    });
  }
  connectedCallback() {
    const height = this.querySelector(".ct-collapsible-body").scrollHeight;
    this.style.setProperty("--ct-body-height", height + "px");
  }
  toggle() {
    if(this.hasAttribute("opened")) {
      this.removeAttribute("opened");
    } else {
      this.setAttribute("opened", "");
    }
  }
}
customElements.define("ct-collapsible", ct_collapsible);